import React, {Component} from 'react';

import {Link as Link} from "react-router-dom";
import {
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Col,
    Form,
    FormGroup,
    FormText,
    Input,
    Label,
    Row,
    Card,
    CardBody,
    CardHeader
} from "reactstrap";
import RoleList from "../../components/user/RoleList";
import UserService from "../../services/UserService";
import SweetAlert from 'react-bootstrap-sweetalert';
import ResetPasswordModal from "../auth/ResetPasswordModal";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {EventBus} from "../../components/events/event"
import SearchDebtorAcccount from "../../components/search/SearchDebtorAcccount";
import { handleErrorMessage } from '../../services/CommonService';
import {BUNNINGS_STORE_ACCOUNT_IDs} from "../../store/AppConstants";


export default class UserManagePage extends Component {
   // static displayName = UserManagePage.name;

    constructor(props) {
        super(props);

        let user;
        let editing = false;
        if (props.location.state.user.userId) {
            editing = true;
            const dbuser = props.location.state.user;
            user = {
                id: dbuser.userId,
                firstname: dbuser.firstName,
                lastname: dbuser.lastName,
                email: dbuser.emailAddress,
                password: '',
                userCategory: dbuser.userCategory,
                lastPasswordUpdatedDate: dbuser.lastPasswordUpdatedDate,
                username: dbuser.username || '',
            }
        } else {
            user = {
                id: '',
                firstname: '',
                lastname: '',
                email: '',
                password: '',
                userCategory: 'SALLY_USER',
                username: '',
            }
        }

        this.state = {
            editing: editing,
            user: user,
            saving: false,
            formValid: false,
            formErrors: {},
            newrole: {},
            newUserRoleId: '0',
            loading: {
                saveUser: false,
                addRole: false,
                removeRole: false,
                updatePassword: false
            },
            showAlert: false,
            msg: "",
            basicType: "",
            basicTitle: "",
            openResetPasswordModel: false,
            clearResetPasswordModel: false,
            userData: [],
            flag: false,
            userCategories: [],
            activeTab: props.location.state.activeTab,
            autoGeneratedUsername: '',
            originalUsername: user.username || '',
            showSwishWarning: false,
            swishWarningUsername: '',
        };
        this.userService = new UserService();
        //this.customerService = new CustomerService();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleEmailBlur = this.handleEmailBlur.bind(this);
        this.handleRoleChange = this.handleRoleChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.addRole = this.addRole.bind(this);
        this.removeRole = this.removeRole.bind(this);
        this.refreshUserRoles = this.refreshUserRoles.bind(this);
        this.closeAlert = this.closeAlert.bind(this);
        this.closeSwishWarning = this.closeSwishWarning.bind(this);
        this.proceedWithSave = this.proceedWithSave.bind(this);
        this.toggleOpenResetPasswordModal = this.toggleOpenResetPasswordModal.bind(this);
        this.toggleClearResetPasswordModal = this.toggleClearResetPasswordModal.bind(this);
        this.activateRole = this.activateRole.bind(this);
        this.setPrivilege = this.setPrivilege.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.handleNewUserRoleChange = this.handleNewUserRoleChange.bind(this);
    }

    componentDidMount() {
        let { activeTab,user } = this.state;
        this.refreshUserRoles();
        this.userService.getUser().then(data => {
            this.setState({userData: data}, () => this.setPrivilege());
        });

        this.userService.getUserCategories().then(res => {
            var userCategories = res.data;
            this.setState(prevState => {
                let user = {...prevState.user};
                if (activeTab === 'customer') {
                    userCategories = userCategories.filter(x => x.name === 'SHP_DEBTOR');
                    user.userCategory = 'SHP_DEBTOR';
                }
                return { userCategories, user };
            });
        });

        if (!this.state.editing && activeTab !== 'customer') {
            this.userService.generateUsername().then(res => {
                const generated = res.data.username;
                let updatedUser = {...this.state.user, username: generated};
                this.setState({user: updatedUser, autoGeneratedUsername: generated, originalUsername: generated});
            }).catch(() => {});
        }
    }

    setPrivilege() {
        this.setState({flag: this.userService.hasPrivilege(this.state.userData, "user-write")})
    }

    refreshUserRoles() {
        //if we are editing the user then fetch its existing roles
        if (this.state.editing) {
            this.userService.listUserRoles(this.state.user.id)
                .then(response => {
                    this.setState({roles: response.data})
                }).catch(error => {
                alert(handleErrorMessage(error));
            })
        }
        EventBus.publish('update-userRoles', {});
    }

    handleNewUserRoleChange(roleId) {
        this.setState({ newUserRoleId: roleId });
    }


    handleChange(change,key) {
        let user = {...this.state.user};
        user[key] = change;
        let additionalState = {};
        if (key === 'userCategory') {
            additionalState.newUserRoleId = '0';
        }
        this.setState({ user: user, ...additionalState }, () => {
            if (key === 'accountID') {
                this.getAccountStoreCode(change);
            }
        });
    }

    handleEmailBlur() {
        const {user} = this.state;
        if (user.userCategory !== 'SALLY_USER' || !user.email || user.email.trim().length < 3) return;

        this.userService.lookupSwishUsername(user.email).then(res => {
            const swishUsername = res.data.username;
            if (swishUsername) {
                let updatedUser = {...user, username: swishUsername};
                this.setState({user: updatedUser});
            }
        }).catch(() => {});
    }

    handleCancel() {
        this.props.history.push('/users')
    }

    handleRoleChange(roleId) {
        let newrole = this.state.newrole;
        newrole.roleId = roleId;
        if (newrole.roleId) {

        }
        this.setState({newrole: newrole})

    }

    getAccountStoreCode(accountID) {
        let { newrole, user } = this.state;
        this.userService.getAccountStoreCode(accountID).then(response => {
            if (response.data) {
                newrole.storeCode = response.data;
                if (user.userCategory === 'SHP_DEBTOR' && !this.state.editing) {
                    user.storeCode = response.data;
                }
                this.setState({ newrole,user });
            }
        }).catch(error => {
            toast.error(handleErrorMessage(error), { position: toast.POSITION.BOTTOM_CENTER });
        });
    } 

    handleAccountChange(accountID) {
        let newrole = this.state.newrole;
        if (accountID) {
            newrole.account = accountID;
            this.getAccountStoreCode(accountID);
        } else {
            newrole.account = "";
            newrole.accoutName = "";
            newrole.storeCode = "";

        }
        this.setState({newrole: newrole});

    }

    validateForm(user, name) {
        let formErrors = {};
        let fnv = user.firstname.trim().length > 1;
        let lnv = user.lastname.trim().length > 1;
        let emv = user.email.trim().length > 3;
        let pwv = this.state.editing ? true : user.password.trim().length > 3;
        let ucv = user.userCategory ? true : false;
        // Role required for new internal users
        let rov = this.state.editing || !user.userCategory || user.userCategory !== 'SALLY_USER' ? true :
            (this.state.newUserRoleId && this.state.newUserRoleId !== '0');
        // Account required for new external users
        let acv = this.state.editing || user.userCategory !== 'SHP_DEBTOR' ? true : (user.accountID ? true : false);

        if (!fnv) formErrors.firstname = "Input valid first name";
        if (!lnv) formErrors.lastname = "Input valid last name";
        if (!emv) formErrors.email = "Input valid email";
        if (!pwv) formErrors.password = "Input valid password";
        if (!ucv) formErrors.userCategory = "Select category";
        if (!rov) formErrors.newUserRole = "Select a role";
        if (!acv) formErrors.accountID = "Select an account";

        let result = { valid: fnv && lnv && emv && pwv && ucv && rov && acv, formErrors: formErrors };
        return result;
    }

    activateRole(role) {

        this.userService.setPrimaryRole(role.id).then(response => {
            this.refreshUserRoles();
        }).catch(error => {
            alert(handleErrorMessage(error));
        })
    }

    async handleSubmit(event) {
        event.preventDefault();

        let result = this.validateForm(this.state.user);
        if (!result.valid) {
            this.setState({formErrors: result.formErrors});
            return;
        }

        const {user, autoGeneratedUsername, originalUsername} = this.state;

        if (user.userCategory === 'SALLY_USER' && user.username && user.username !== autoGeneratedUsername && user.username !== originalUsername) {
            try {
                const res = await this.userService.validateSwishUsername(user.username);
                if (!res.data.isValid) {
                    let fallback = autoGeneratedUsername;
                    if (!fallback) {
                        const genRes = await this.userService.generateUsername();
                        fallback = genRes.data.username;
                        this.setState({autoGeneratedUsername: fallback});
                    }
                    this.setState({showSwishWarning: true, swishWarningUsername: fallback});
                    return;
                }
            } catch (e) {
                // if SWISH is unreachable, fall through and save with current username
            }
        }

        this.proceedWithSave();
    }

    proceedWithSave() {
        const {user} = this.state;
        const payload = {
            id: user.id,
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            password: user.password,
            userCategory: user.userCategory,
            accountID: user.accountID,
            storeCode: user.storeCode,
            username: user.username,
            roleId: this.state.newUserRoleId
        };

        let loading = this.state.loading;
        loading.saveUser = true;
        this.setState({loading, formErrors: {}});

        this.userService.saveUser(payload).then(response => {
            let dbuser = response.data;
            if (dbuser) {
                let savedUser = {
                    id: dbuser.userId,
                    firstname: dbuser.firstName,
                    lastname: dbuser.lastName,
                    email: dbuser.emailAddress,
                    password: '',
                    userCategory: dbuser.userCategory,
                    lastPasswordUpdatedDate: dbuser.lastPasswordUpdatedDate,
                    username: dbuser.username || '',
                };

                let loading = this.state.loading;
                loading.saveUser = false;

                if (this.state.editing) {
                    this.setState({
                        user: savedUser,
                        editing: true,
                        loading: loading,
                        originalUsername: savedUser.username,
                        showAlert: true,
                        msg: "User updated !",
                        basicTitle: "Success",
                        basicType: "success"
                    });
                } else {
                    this.setState({
                        user: savedUser,
                        editing: true,
                        loading: loading,
                        originalUsername: savedUser.username,
                        newUserRoleId: '0',
                        showAlert: true,
                        msg: "User created successfully. Modify role(s) if required.",
                        basicTitle: "Success",
                        basicType: "success"
                    }, () => {
                        this.refreshUserRoles();
                    });
                }
            }
        }, error => {
            let msg = handleErrorMessage(error);
            let loading = this.state.loading;
            loading.saveUser = false;
            this.setState({showAlert: true, msg: msg, basicTitle: "Error", basicType: "danger", loading: loading});
        });
    }

    closeSwishWarning() {
        const {swishWarningUsername} = this.state;
        let user = {...this.state.user, username: swishWarningUsername};
        this.setState({showSwishWarning: false, user}, () => this.proceedWithSave());
    }

    closeAlert() {
        this.setState({showAlert: false});
    }

    addRole() {
        let { newrole } = this.state;
        if (!newrole.roleId || newrole.roleId === "0" || newrole.roleId === 0) {
            toast.error("Please select a role first.", { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }

        let loading = this.state.loading;
        loading.addRole = true;
        this.setState({ loading: loading });

        this.userService.addRole(this.state.user.id, newrole)
            .then(ok => {
                loading = this.state.loading;
                loading.addRole = false;
                this.setState({ loading: loading });
                toast.success("Role added successfully.", { position: toast.POSITION.BOTTOM_CENTER });
                this.refreshUserRoles();
            }, reject => {
                loading = this.state.loading;
                loading.addRole = false;
                this.setState({ loading: loading });
                let msg = (reject && (reject.Message || reject.message)) || "Failed to add role. Please try again.";
                toast.error(msg, { position: toast.POSITION.BOTTOM_CENTER });
            });
    }

    removeRole(id) {
        this.userService.removeRole(id).then(this.refreshUserRoles)
    }

    updatePassword(password, repassword) {
        let {loading, user} = this.state;

        loading.updatePassword = true;
        this.setState({loading});
        this.userService.updatePasswordByAdmin(password, repassword, user.email).then(response => {
            toast.success("Password updated!", {
                position: toast.POSITION.BOTTOM_CENTER
            });

            let dbuser = response.data;
            if (dbuser) {

                user = {
                    id: dbuser.userId,
                    firstname: dbuser.firstName,
                    lastname: dbuser.lastName,
                    email: dbuser.emailAddress,
                    password: '',
                    userCategory: dbuser.userCategory,
                    lastPasswordUpdatedDate: dbuser.lastPasswordUpdatedDate
                };
            }

            loading.updatePassword = false;
            this.setState({ loading, user });
            this.toggleOpenResetPasswordModal(false);
        }).catch(error => {
            loading.updatePassword = false;
            this.setState({loading});
            console.log(error);
            toast.error(handleErrorMessage(error), {
                position: toast.POSITION.BOTTOM_CENTER
            });
        });
    }

    toggleOpenResetPasswordModal(change) {
        let {clearResetPasswordModel} = this.state;
        if (!change) {
            clearResetPasswordModel = true;
        }
        this.setState({openResetPasswordModel: change, clearResetPasswordModel});
    }

    toggleClearResetPasswordModal(change) {
        this.setState({clearResetPasswordModel: change});
    }

    render() {

        let user = this.state.user;
        let roles = this.state.roles;
        let loading = this.state.loading;
        let formErrors = this.state.formErrors;
        let newrole = this.state.newrole;
        let openResetPasswordModel = this.state.openResetPasswordModel;
        let clearResetPasswordModel = this.state.clearResetPasswordModel;
        let isInternalUser = user.userCategory === 'SALLY_USER';

        return (
            <div>
                <Breadcrumb tag="nav" listTag="div">
                    <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem><Link to="/users">Users</Link></BreadcrumbItem>
                    <BreadcrumbItem active>{this.state.editing ? "Update user" : "Add user"}</BreadcrumbItem>
                </Breadcrumb>
                {this.state.showAlert ?
                    <SweetAlert show={this.state.showAlert} type={this.state.basicType} title={this.state.basicTitle}
                                onConfirm={this.closeAlert}> {this.state.msg} </SweetAlert> : null}
                {this.state.showSwishWarning ?
                    <SweetAlert warning title="SWISH Username Not Found"
                                onConfirm={this.closeSwishWarning}>
                        {`The SWISH Username does not exist. System will use the randomly generated 5 character Username: ${this.state.swishWarningUsername}`}
                    </SweetAlert> : null}
                <div>
                    <Row>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            <Card>
                                <CardHeader>
                                    <Row>
                                        <Col><h5
                                            className={"text-left"}>{this.state.editing ? "Update user" : "Add user"}</h5>
                                        </Col>
                                        {this.state.editing ?
                                            <Col>
                                                <div className={"text-right"}>
                                                    <Button size={"sm"} color={"primary"}
                                                            onClick={() => this.toggleOpenResetPasswordModal(true)}>Change
                                                        Password</Button>
                                                </div>
                                            </Col> : null}

                                    </Row>

                                </CardHeader>
                                <CardBody>
                                    <Form onSubmit={this.handleSubmit} autoComplete="off">
                                        <FormGroup>
                                            <Label for="firstname">First Name*</Label>
                                            <Input type="text" name="firstname" id="firstname"
                                                   value={user.firstname || ''}
                                                   onChange={(e)=>this.handleChange(e.target.value,e.target.name)} autoComplete="off"/>
                                            <FormText color="danger">{formErrors.firstname}</FormText>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="lastname">Last Name*</Label>
                                            <Input type="text" name="lastname" id="lastname"
                                                   value={user.lastname || ''}
                                                onChange={(e) => this.handleChange(e.target.value, e.target.name)} autoComplete="off"/>
                                            <FormText color="danger">{formErrors.lastname}</FormText>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="email">Email*</Label>
                                            <Input type="text" name="email" id="email"
                                                   value={user.email || ''}
                                                   onChange={(e) => this.handleChange(e.target.value, e.target.name)}
                                                   onBlur={this.handleEmailBlur}
                                                   autoComplete="off"/>
                                            <FormText color="danger">{formErrors.email}</FormText>
                                        </FormGroup>

                                        {!this.state.editing ? <FormGroup>
                                            <Label for="password">Password*</Label>
                                            <Input type="password" name="password" id="password"
                                                   value={user.password || ''}
                                                onChange={(e) => this.handleChange(e.target.value, e.target.name)} autoComplete="off"/>
                                            <FormText color="danger">{formErrors.password}</FormText>
                                        </FormGroup> : null}

                                        <FormGroup>
                                            <Label for="category">Category*</Label>
                                            <Input type="select" name="userCategory" id="userCategory"
                                                value={user.userCategory || ''}
                                                onChange={(e) => this.handleChange(e.target.value, e.target.name)}>
                                                <option value="">Select</option>
                                                {(this.state.userCategories || []).map((category, index) => (
                                                    <option key={index} value={category.name}>{category.description}</option>
                                                ))}
                                            </Input>
                                            <FormText color="danger">{formErrors.userCategory}</FormText>
                                        </FormGroup>

                                        {isInternalUser ?
                                            <FormGroup>
                                                <Label for="username">SWISH Username</Label>
                                                <Input type="text" name="username" id="username"
                                                       value={user.username || ''}
                                                       onChange={(e) => this.handleChange(e.target.value, e.target.name)}
                                                       autoComplete="off"/>
                                                <FormText>Must match the SWISH username. Auto-generated if not found in SWISH.</FormText>
                                            </FormGroup> : null}

                                        {user.userCategory === 'SHP_DEBTOR' && !this.state.editing ?
                                            <FormGroup>
                                                <Label for="password">AccountID*</Label>
                                                <SearchDebtorAcccount handleAccountChange={(accountID) => this.handleChange(accountID, 'accountID')}
                                                                              selectedAccountID={user.accountID}
                                                                              defaultAccountID={user.accountID}
                                                                              includeChildren={true}
                                                                              excludeClosedandInactive={false}
                                                                              parentAccountIDs={BUNNINGS_STORE_ACCOUNT_IDs}
                                                                              excludeAccountID=""
                                                        />
                                                <FormText color="danger">{formErrors.accountID}</FormText>
                                            </FormGroup> : null}


                                        {user.userCategory === 'SALLY_USER' && !this.state.editing ?
                                            <FormGroup>
                                                <Label>Role*</Label>
                                                <RoleList
                                                    selectedrole={this.state.newUserRoleId}
                                                    roleChangeHandler={this.handleNewUserRoleChange}
                                                />
                                                <FormText color="danger">{formErrors.newUserRole}</FormText>
                                            </FormGroup> : null}

                                        <FormGroup>
                                            {this.state.flag ? <div className="pb-2 text-right">
                                                <Button size="sm" color="secondary"
                                                    onClick={() => this.handleCancel()}>Cancel</Button><span>&nbsp;&nbsp;</span>
                                                <Button size="sm" color="primary"
                                                        type="submit">{this.state.editing ? (this.state.loading.saveUser ? "Updating..." : "Update") : (this.state.loading.saveUser ? "Saving..." : "Save")}</Button>
                                            </div> : null}
                                        </FormGroup>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                        {
                            user.id
                                ? <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <Card>
                                        <CardHeader>
                                            <h5> Manage Role</h5>
                                        </CardHeader>
                                        <CardBody>
                                            <table className='table table-striped'>
                                                <thead>
                                                <tr>
                                                    <th>Account</th>
                                                    <th>Store Code</th>
                                                    <th>Role</th>
                                                    <th>Active</th>
                                                    <th>Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                {roles && roles.map((role, index) =>
                                                    <tr key={index}>
                                                        <td>{role.account || "N/A"}</td>
                                                        <td>{role.storeCode || "N/A"}</td>
                                                        <td>{role.roleName}</td>
                                                        <td><Button size={"sm"}
                                                                    outline={!role.isPrimary} color={"success"}
                                                                    onClick={() => this.activateRole(role)}>
                                                            <i hidden={!role.isPrimary} className="fa fa-check pr-2"
                                                               aria-hidden="true"/>
                                                            {role.isPrimary ? "Active" : "Activate"}
                                                        </Button></td>
                                                        <td><Button size="sm" color="primary"
                                                                    onClick={() => this.removeRole(role.id)}>{this.state.loading.removeRole ? "Removing.." : "Remove"}</Button>
                                                        </td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <td colSpan={2}>
                                                        <SearchDebtorAcccount handleAccountChange={this.handleAccountChange}
                                                                              selectedAccountID={newrole.account}
                                                                              defaultAccountID={newrole.account}
                                                                              includeChildren={true}
                                                                              excludeClosedandInactive={false}
                                                                              parentAccountIDs={BUNNINGS_STORE_ACCOUNT_IDs}
                                                                              excludeAccountID=""
                                                        />

                                                        </td>
                                                        <td className="text-center">{newrole.storeCode ? newrole.storeCode:'N/A'}</td>
                                                    <td>
                                                        <RoleList selectedrole={newrole.roleId}
                                                                  roleChangeHandler={this.handleRoleChange}/>
                                                    </td>
                                                    <td>
                                                        <Button size="sm" color="primary"
                                                                onClick={this.addRole}>{this.state.loading.addRole ? "Adding.." : "Add"}</Button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </CardBody>
                                    </Card>
                                </Col>
                                : null
                        }
                    </Row>
                </div>
                <ResetPasswordModal
                    user={user}
                    isOpen={openResetPasswordModel}
                    toggleModel={this.toggleOpenResetPasswordModal}
                    toggleClear={this.toggleClearResetPasswordModal}
                    updatePassword={this.updatePassword}
                    loading={loading.updatePassword}
                    clear={clearResetPasswordModel}
                />
                <ToastContainer/>
            </div>
        );
    }
}
